import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, } from "../../../services/api";

// Get suspicious list
export const financeLisitingRequest = (page = 1, pageSize = 50) => {
  return async (dispatch) => {
    const url = `${ApiURLs.FINANCE}?page=${page}&limit=${pageSize}`;
    dispatch({ type: "GET_FINANCE_REQUEST" });

    try {
      const financeData = await fetchData(url);
      if (financeData.status === 1) {
        dispatch({
          type: "GET_FINANCE_REQUEST_SUCCESS",
          payload: financeData.data.result || [],
          total: financeData.data.total || 0,
        });
      } else {
        dispatch({ type: "GET_FINANCE_REQUEST_FAILED" });
      }
    } catch (error) {
      console.error("Fetch finance error:", error);
      dispatch({ type: "GET_FINANCE_REQUEST_FAILED" });
    }
  };
};

// Delete finance records by activity IDs
export const deleteFinance = (id) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_FINANCE_REQUEST" });
    try {
      const url = `${ApiURLs.FINANCE}?id=${id}`;
      const response = await deleteData(url);

      if (response.status === 1) {
        dispatch({ type: "DELETE_FINANCE_SUCCESS" });
        dispatch(financeLisitingRequest()); // Refresh the list
      } else {
        dispatch({ type: "DELETE_FINANCE_FAILED" });
      }
    } catch (error) {
      console.error("Delete finance error:", error);
      dispatch({ type: "DELETE_FINANCE_FAILED" });
    }
  };
};



